export const HOUSE_PAGE_STRINGS = {
  'infoIcons.noParking': 'No Parking',
  'tour.tourThisHome': 'Tour This Home',
  'tour.touringSoon': 'Touring Soon',
  'tour.rescheduleTour': 'Reschedule Tour',
  'tour.editAvailability': 'Change Availability',
  'tour.seePhoto': 'See Photo',
  'tour.seePhotosWithNumber': 'See All {number} Photos',
  'tour.selfTourAvailable': 'Self Tours Available',
  'tour.seeTimes': 'See Times',
  'tour.signIn': 'Sign\u00a0In\u00a0To\u00a0See\u00a0Times!',
  'tour.errorMessages': {
    HAS_EXISTING_SCHEDULED_TOURS:
      'Hmm, looks like you already have a tour that clashes with this one. Please choose another time, or cancel the one you have\u00a0booked.',
    TOUR_SLOT_UNAVAILABLE:
      'Oh no, looks like someone just booked that slot! Please select another\u00a0one.',
  },
  'tour.youAreSet': "You're all set!",
  'tour.weLookForward': 'We hope you enjoy your visit and love this\u00a0home.',
  'tour.cancel': 'Cancel',
  'tour.cancel.areYouSure': 'Are you sure you want to\u00a0cancel?',
  'tour.cancel.noLongerInterested':
    'I am no longer interested in this\u00a0home.',
  'tour.reschedule': 'Reschedule',
  'tour.startSelfTour': 'Start My Self Tour',
  'tour.rescheduleInstead': 'Reschedule Instead',
  'tour.cancelTour': 'Cancel Tour',
  'tour.done': 'Done',
  'tour.cantConfirm': "Oh no! We can't confirm your\u00a0spot.",
  'tour.tourIsFull':
    "It looks like the tour is now full. We try to keep tours small so you are able to view the home in a comfortable manner while also respecting current residents. We'll invite you to the next tour as soon as it's\u00a0scheduled.",
  'tour.viewListings': 'View Listings',
  'tour.comeSeeThisHome': 'Come see this Belong\u00a0home!',
  'tour.chooseHowToSee': "Choose how you'd like to see the\u00a0home.",
  'tour.selfTour': 'Self Tour',
  'tour.selfTourDescription':
    'Visit any time that suits you, receive a code to unlock the home, and tour at your own\u00a0pace.',
  'tour.selfTourToday': 'Today',
  'tour.selfTourTomorrow': 'Tomorrow',
  'tour.selfTourMoreTimes': '+{count} more\u00a0times',
  'tour.selfTourOneMoreTime': '+1 more\u00a0time',
  'tour.signInForGroupTours': 'Sign In For Group Tours',
  'tour.or': 'Or',
  'tour.attendGroupTour': 'Join a scheduled group\u00a0tour.',
  'tour.noGroupTours':
    'There are no group tours scheduled for this home right now.',
  'tour.bookingError':
    'There was an error booking your tour. Please try\u00a0again.',
  'tour.book': 'Book',
  'tour.cantMakeIt': "Can't Make It",
  'tour.occupied': 'Occupied',
  'tour.doesntWorkForYou': "Doesn't work for you?",
  'tour.sendAvailability': 'Send us your availability',
  'tour.sendAvailabilitySuccessToast':
    'We’ll email you shortly, and invite you to any new tours we add.',
  'tour.whenCanYouTour': 'When can you tour?',
  'tour.whenCanYouTourSubtitle':
    'Give us 3 days and time periods that work best for\u00a0you.',
  'tour.whenCanYouTourSubtitle2':
    'We will do our best to schedule a tour as soon as\u00a0possible.',
  'tour.genericRequestError':
    'There was an error saving your\u00a0availability.',
  'tour.minDatesValidation': 'We need a minimum of 3 days and\u00a0times.',
  'tour.passedDatesValidation':
    "You can't set your availability for today or a past\u00a0date.",
  'tour.comingSoonTourTitle': "This home isn't ready for tours\u00a0yet.",
  'tour.comingSoonTourSubtitle':
    'Tours open {date}, so pick your preferred times to get ahead of the\u00a0line.',
  'tour.comingSoonDateValidation':
    'This home is not available for touring yet. Please select a later\u00a0date.',
  'tour.comingSoonCtaReason': 'Starting {date}',
  apply: 'Apply',

  'ownedBy.title': 'Owned By',
  'ownedBy.belongMember': 'Belong Member Since',

  'occupied_tour.bullet_list.title': 'What is an occupied group\u00a0tour?',
  'occupied_tour.bullet_list.first':
    'Occupied tours are hosted by our tour hosts but current residents may or may not be at\u00a0home.',
  'occupied_tour.bullet_list.second':
    'We try to keep these groups small, to a maximum of 10 people so you are able to enjoy the space. In an effort to keep these tours small, please limit the number of guests that\u00a0attend.',
  'occupied_tour.bullet_list.third':
    "While enjoying the home, please be respectful around the current Residents' belongings.",

  'features.title': 'Features',
  'relatedHomes.title': 'Looking for something similar?',

  'depositTabs.depositFree.tooltip':
    'Qualified residents have the option of paying a low, nonrefundable fee instead of an upfront cash deposit. Use the money to invest, save, or buy something\u00a0nice!',
  'depositTabs.liabilityCoverage.tooltip':
    "Liability Coverage is required to live in a Belong home. For your convenience, you are automatically enrolled in liability coverage with personal property protection. You may change this coverage, or get your own Renter's Insurance policy if you\u00a0prefer.",

  'utilities.included': 'Utilities Included',
  'utilities.none': 'None',
  'utilities.charges': 'Additional Utility Charges',
  'utilities.purchases': 'Available For Purchases',

  'communal.display': 'Communal',

  'inspection.title': 'The Inspection',
};
